import { render, staticRenderFns } from "./SliderImage.vue?vue&type=template&id=83dbe54a&scoped=true&"
import script from "./SliderImage.vue?vue&type=script&lang=ts&"
export * from "./SliderImage.vue?vue&type=script&lang=ts&"
import style0 from "./SliderImage.vue?vue&type=style&index=0&id=83dbe54a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dbe54a",
  null
  
)

export default component.exports